export const nextYearMonth = (
  year: number,
  month: number,
): { year: number; month: number } => {
  let nextMonth = month + 1;
  let nextYear = year;

  if (nextMonth >= 13) {
    nextMonth = 1;
    nextYear = year + 1;
  }

  return { year: nextYear, month: nextMonth };
};

export const previousYearMonth = (
  year: number,
  month: number,
): { year: number; month: number } => {
  let previousMonth = month - 1;
  let previousYear = year;

  if (previousMonth <= 0) {
    previousMonth = 12;
    previousYear = year - 1;
  }

  return { year: previousYear, month: previousMonth };
};
